import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared/shared.module';
import { SocialFormComponent } from './social-form.component';
import { SocialFormService } from './social-form.service';
import { DxValidatorModule } from 'devextreme-angular';

@NgModule({
    imports: [SharedModule, DxValidatorModule],
  declarations: [SocialFormComponent],
  exports: [SocialFormComponent],
  providers: [SocialFormService],
})
export class SocialFormModule {}
